import React from 'react';
import { Box, Container, Heading, Text, VStack, SimpleGrid, HStack, Icon } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaCheckCircle } from 'react-icons/fa';

const MotionBox = motion(Box);

const AIMasteryTrustBadges = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bg="brand.50">
      <Container maxW="container.xl">
        <VStack spacing={12}>
          {/* Title */}
          <VStack spacing={4} textAlign="center">
            <Heading
              size="2xl"
              fontWeight="900"
              color="brand.800"
            >
              {data.title}
            </Heading>
            {data.subtitle && (
              <Text fontSize="lg" color="brand.600" maxW="3xl">
                {data.subtitle}
              </Text>
            )}
          </VStack>

          {/* Badges Grid */}
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} w="full">
            {data.badges?.map((badge, index) => (
              <MotionBox
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                <Box
                  p={8}
                  bg="white"
                  borderRadius="2xl"
                  boxShadow="0 4px 20px rgba(0,0,0,0.08)"
                  h="full"
                  _hover={{
                    boxShadow: '0 12px 40px rgba(128,90,213,0.2)',
                  }}
                  transition="all 0.3s"
                >
                  <VStack spacing={6} align="flex-start">
                    <Heading size="lg" color="purple.600">
                      {badge.title}
                    </Heading>
                    <VStack spacing={3} align="flex-start" w="full">
                      {badge.items?.map((item, i) => (
                        <HStack key={i} align="flex-start" spacing={3}>
                          <Icon
                            as={FaCheckCircle}
                            boxSize={5}
                            color="accent.green"
                            mt={1}
                            flexShrink={0}
                          />
                          <Text color="brand.600" fontSize="md">
                            {item}
                          </Text>
                        </HStack>
                      ))}
                    </VStack>
                  </VStack>
                </Box>
              </MotionBox>
            ))}
          </SimpleGrid>

          {/* Final Statement */}
          {data.finalStatement && (
            <MotionBox
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
              w="full"
            >
              <Box
                p={8}
                bgGradient="linear(to-r, purple.600, purple.800)"
                borderRadius="2xl"
                textAlign="center"
              >
                <VStack spacing={4}>
                  <Heading size="md" color="white">
                    {data.finalStatement.title}
                  </Heading>
                  <Text fontSize="lg" color="whiteAlpha.900" maxW="3xl">
                    {data.finalStatement.text}
                  </Text>
                </VStack>
              </Box>
            </MotionBox>
          )}

          {/* Visual Placeholder */}
          {data.visualPlaceholder && (
            <Box
              p={6}
              bg="gray.100"
              borderRadius="xl"
              borderStyle="dashed"
              borderWidth="2px"
              borderColor="gray.300"
              textAlign="center"
              w="full"
            >
              <Text color="gray.600" fontSize="sm" fontStyle="italic">
                {data.visualPlaceholder}
              </Text>
            </Box>
          )}
        </VStack>
      </Container>
    </Box>
  );
};

export default AIMasteryTrustBadges;
